<template>
  <b-modal
    v-if="active"
    v-model="showModal"
    :no-close-on-backdrop="!isImpersonating"
    :no-close-on-esc="!isImpersonating"
    :hide-header="true"
    :hide-footer="true"
  >
    <h5 class="text-center mb-4">Please add your address to receive your TapEngine Cards.</h5>
    <ValidationObserver
      v-slot="{ handleSubmit, invalid, touched }"
      ref="addressForm"
    >
      <form class="address-form" @submit.prevent="handleSubmit(updateAddress)">
        <div class="row">
          <div class="col-12">
            <TextInput v-model="user.address.address" name="address.address" label="Address" type="text" />
          </div>
        </div>
        <div class="row">
          <div class="col-sm-6">
            <TextInput v-model="user.address.city" name="address.city" label="City" type="text" />
          </div>
          <div class="col-sm-6">
            <TextInput v-model="user.address.state" name="address.state" label="State" type="text" />
          </div>
        </div>
        <div class="row">
          <div class="col-sm-6">
            <TextInput v-model="user.address.zip" name="address.zip" label="Zip" type="text" />
          </div>
          <div class="col-sm-6">
            <ValidationProvider v-slot="{ errors }" name="address.country">
              <div class="form-group">
                <label class="form-control-label">Country</label>
                <select
                  v-model="user.address.country"
                  name="address.country"
                  class="form-control"
                  :class="{ 'is-invalid': errors.length }"
                >
                  <option v-for="country in countries" :key="country.id" :value="country.iso2">
                    {{ country.name }}
                  </option>
                </select>
                <span v-show="errors.length" class="text-danger">{{ errors[0] }}</span>
              </div>
            </ValidationProvider>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <b-button
              variant="primary"
              class="btn-dark-blue w-100"
              :disabled="updatingAddress || (invalid && touched)"
              type="submit"
            >
              <b-spinner v-if="updatingAddress" small />
              <span v-else>Submit</span>
            </b-button>
          </div>
        </div>
      </form>
    </ValidationObserver>
  </b-modal>
</template>

<script>
import Countries from '@src/countries'
import { agencyTapEngineAddressIncomplete } from '@utils/agencyTapEngineAddress'

export default {
  data() {
    return {
      updatingAddress: false,
      currentlyTyping: false,
    }
  },

  computed: {
    user() {
      return this.$store.getters['auth/user']
    },

    isImpersonating() {
      return this.$store.getters['auth/isImpersonating']
    },

    isAgencyRoute() {
      return this.$route.path.startsWith('/agency')
    },

    active() {
      return (
        this.user &&
        this.user.role === 'Agency' &&
        this.user.has_te &&
        this.isAgencyRoute
      )
    },

    addressIncomplete() {
      return agencyTapEngineAddressIncomplete(this.user)
    },

    showModal: {
      get() {
        return this.active && (this.addressIncomplete || this.currentlyTyping)
      },
      set(value) {
        if (!value) {
          this.currentlyTyping = false
        }
      },
    },

    countries() {
      return Countries
    },
  },

  watch: {
    'user.address': {
      handler() {
        if (this.active && this.addressIncomplete) {
          this.currentlyTyping = true
        }
      },
      deep: true,
    },

    active: {
      immediate: true,
      handler(isActive) {
        if (isActive) {
          this.ensureAddressDefaults()
        }
      },
    },
  },

  methods: {
    ensureAddressDefaults() {
      if (this.user?.address && this.user.address.country === '') {
        this.user.address.country = 'US'
      }
    },

    updateAddress() {
      this.updatingAddress = true
      const params = {
        address: this.user?.address,
        setting_form: 'address',
      }
      this.$store
        .dispatch('agency/editSettings', params)
        .then(() => {
          this.updatingAddress = false
          this.currentlyTyping = false
        })
        .catch((err) => {
          if (err.response?.data?.errors) {
            this.$refs.addressForm.setErrors(err.response.data.errors)
          }
          this.updatingAddress = false
        })
    },
  },
}
</script>
